


























import { defineComponent } from '@nuxtjs/composition-api';
import { useBundleProductContext } from '~/features/productBundle';

export default defineComponent({
  name: 'ProductBundleCustomizer',
  setup() {
    const { onSelect, items, selectedOptions, disableBundleOptions } = useBundleProductContext();

    return {
      items,
      handleOnOptionSelect: onSelect,
      selectedOptions,
      disableBundleOptions,
    };
  },
});
